/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Más información",
  "CookieMessage.old.text":
    "El funcionamiento correcto de nuestra tienda web requiere el empleo de cookies. Consulte nuestra normativa sobre cookies. ",
  "CookieMessage.link": "Aceptar cookies",
  "CookieMessage.more_information":
    "Más información sobre las cookies de Kramp",
  "CookieMessage.return": "Volver",
  "CookieMessage.intro.body":
    "Utilizamos cookies propias y de terceros. Por supuesto, nos aseguramos de proteger su privacidad. Al aceptar las cookies, permite que nuestro sitio web funcione correctamente. Algunos ejemplos de uso de las cookies son:",
  "CookieMessage.intro.list.1": "Inicio de sesión automático en Mi cuenta",
  "CookieMessage.intro.list.2":
    "Análisis del comportamiento del visitante para mejorar el sitio web",
  "CookieMessage.intro.list.3":
    "Creación de perfiles de clientes que nos permite ofrecerle publicidad y ofertas relacionadas con sus preferencias.",
  "CookieMessage.intro.extra":
    'Puede obtner más información o modificar su <a>configuración</a> en: <a href="{legalLink}">declaración de privacidad y cookies</a>.',
  "CookieMessage.intro.title": "Kramp utiliza cookies",
  "CookieMessage.settings.body":
    "Elige entre tres configuraciones de cookies. La configuración estándar",
  "CookieMessage.settings.standard.title": "Estándar (la más popular):",
  "CookieMessage.settings.standard.body":
    "Las cookies se utilizan para el inicio de sesión, pedidos, análisis, ofertas personalizadas y redes sociales. También se utilizan cookies de terceros.",
  "CookieMessage.settings.restricted.title": "Limitada:",
  "CookieMessage.settings.restricted.body":
    "Las cookies se utilizan para el inicio de sesión, pedidos, análisis y ofertas personalizadas.",
  "CookieMessage.settings.highly_restricted.title": "Muy limitada:",
  "CookieMessage.settings.highly_restricted.body":
    "Solo permite el uso de un número mínimo de cookies. Únicamente para el inicio de sesión, pedidos y para que el sitio web funcione correctamente.",
  "CookieMessage.settings.options.title": "Lo que hacemos:",
  "CookieMessage.settings.option.1":
    "Utilizar las cookies para garantizar que el sitio web funciona correctamente",
  "CookieMessage.settings.option.2":
    "Realizar investigaciones sobre el comportamiento de los usuarios",
  "CookieMessage.settings.option.3":
    "Realizar un seguimiento de datos estadísticos personales",
  "CookieMessage.settings.option.4":
    "Mostrar información que pueda resultar de interés",
  "CookieMessage.settings.option.5":
    "Utilizar información para nuestros anuncios",
  "CookieMessage.settings.option.6":
    "Realizar un seguimiento de datos estadísticos anónimos",
  "CookieMessage.settings.option.7": "Compartir sus datos personales",
  "CookieMessage.settings.title": "Configuración de las cookies",
  "CookiePage.url": "politica-de-privacidad-cookies",
};
